export default {
  getBusinessUnits: state => state.businessUnits || [],
};
